import React, { useEffect, useState, useRef } from 'react';
import { portfolioReportsAPI } from '../../services/api';

const PeriodSelector = ({ selectedQuarter, onSelectQuarter, reportingFrequency = 'quarterly' }) => {
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(true);
  const prevFrequencyRef = useRef(reportingFrequency);

  // Fetch available periods from the backend
  useEffect(() => {
    setLoading(true);
    portfolioReportsAPI.getAvailableQuarters('both')
      .then(result => {
        const items = result.periods || [];
        setPeriods(items);
        prevFrequencyRef.current = reportingFrequency;

        // Auto-select first period only if nothing is selected
        if (!selectedQuarter && items.length > 0) {
          onSelectQuarter(items[0].value);
        }
      })
      .catch(err => console.error('Error loading available periods:', err))
      .finally(() => setLoading(false));
  }, [reportingFrequency]); // eslint-disable-line react-hooks/exhaustive-deps

  // If selected period is no longer in the list, select first available
  useEffect(() => {
    if (periods.length > 0 && selectedQuarter && !periods.find(p => p.value === selectedQuarter)) {
      onSelectQuarter(periods[0].value);
    }
  }, [periods, selectedQuarter, onSelectQuarter]);

  return (
    <div className="quarter-selector">
      <h4 className="list-heading">Period</h4>
      <select
        className="quarter-select"
        value={selectedQuarter || ''}
        onChange={(e) => onSelectQuarter(e.target.value)}
        disabled={loading}
      >
        {loading && <option value="">Loading...</option>}
        {periods.map((p) => (
          <option key={p.value} value={p.value}>{p.label}</option>
        ))}
      </select>
    </div>
  );
};

export { PeriodSelector };
export default PeriodSelector;
